import React from 'react'
import './loading.css'
import {HashLoader,ScaleLoader} from "react-spinners"


const Loading = () => {
  return (
    <div className="loadingCont">
    <ScaleLoader
      color="black"
      width={4.5}
      height={"40px"}
      speedMultiplier={1.3}
    />
  </div>
  )
}

export default Loading
